export function loadScript(crossdomain: boolean, file: string, id?: string) {
    return new Promise((resolve, reject) => {
        let timer;
        const scriptTag = document.createElement('script');
        const onerror = _event => {
            clearTimeout(timer);

            const err = new Error(`Loading JS chunk ${file} failed.`);

            scriptTag.parentNode?.removeChild(scriptTag);
            reject(err);
        };

        scriptTag.onload = () => {
            clearTimeout(timer);
            resolve(undefined);
        };

        scriptTag.onerror = onerror;
        scriptTag.src = file;

        if (id) {
            scriptTag.id = id;
        }

        if (crossdomain && !scriptTag.src.startsWith(window.location.origin)) {
            scriptTag.crossOrigin = 'anonymous';
        }

        const head = document.getElementsByTagName('head')[0];

        head.appendChild(scriptTag);

        timer = setTimeout(onerror, 120000);
    });
}
